// Mock data for NFIT Corp landing page

export const companyInfo = {
  name: "NFIT Corp Inc - FZCO",
  domain: "nfitcorp.ae",
  tagline: "Empowering MENA's Digital Future",
  description: "Leading technology solutions provider in Dubai, delivering cutting-edge IoT, Blockchain, and AI solutions across the MENA region.",
  foundedYear: 2024,
  location: "Dubai, UAE"
};

export const heroContent = {
  mainHeading: "Digitally Empowering the MENA Region",
  subHeading: "Advanced IoT, Blockchain & AI Solutions for Enterprise Excellence",
  description: "NFIT Corp partners with global technology leaders to deliver innovative digital solutions across device management, enterprise software, business applications, and e-governance in the Middle East and North Africa.",
  stats: [
    { number: "500+", label: "Enterprise Clients" },
    { number: "15+", label: "MENA Countries" },
    { number: "1M+", label: "Devices Managed" },
    { number: "24/7", label: "Support" }
  ]
};

export const services = [
  {
    id: 1,
    title: "IoT Solutions",
    description: "Comprehensive IoT device management and monitoring solutions for enterprises across MENA region",
    features: ["Smart Device Management", "Real-time Analytics", "Predictive Maintenance", "Cloud Integration"]
  },
  {
    id: 2,
    title: "Blockchain Solutions",
    description: "Secure and transparent blockchain implementations for supply chain, finance, and governance",
    features: ["Supply Chain Transparency", "Smart Contracts", "Digital Identity", "Secure Transactions"]
  },
  {
    id: 3,
    title: "AI & Machine Learning",
    description: "Intelligent automation and decision-making systems powered by advanced AI algorithms",
    features: ["Predictive Analytics", "Process Automation", "Computer Vision", "Natural Language Processing"]
  },
  {
    id: 4,
    title: "Enterprise Software",
    description: "Custom enterprise applications and software solutions tailored for MENA businesses",
    features: ["ERP Solutions", "CRM Systems", "Business Intelligence", "Custom Applications"]
  }
];

export const sectors = [
  {
    title: "E-Governance",
    description: "Digital transformation solutions for government agencies across the MENA region",
    applications: ["Digital Identity Systems", "Online Service Portals", "Smart City Infrastructure", "Citizen Engagement Platforms"]
  },
  {
    title: "Healthcare",
    description: "Advanced healthcare technology solutions for improved patient care and operational efficiency",
    applications: ["Hospital Management Systems", "Telemedicine Platforms", "Medical Device Integration", "Health Analytics"]
  },
  {
    title: "Financial Services",
    description: "Secure fintech solutions for banks and financial institutions in the MENA region",
    applications: ["Digital Banking Solutions", "Payment Gateways", "Fraud Detection", "Regulatory Compliance"]
  },
  {
    title: "Smart Cities",
    description: "Comprehensive smart city solutions for urban development across MENA",
    applications: ["Traffic Management", "Energy Optimization", "Waste Management", "Public Safety Systems"]
  }
];

export const partners = {
  hardware: [
    { name: "HP", logo: "/api/placeholder/120/60", category: "Computing Solutions" },
    { name: "Dell", logo: "/api/placeholder/120/60", category: "Enterprise Hardware" },
    { name: "Apple", logo: "/api/placeholder/120/60", category: "Mobile Solutions" },
    { name: "NVIDIA", logo: "/api/placeholder/120/60", category: "AI & GPU Computing" },
    { name: "Samsung", logo: "/api/placeholder/120/60", category: "Mobile & Display Technology" }
  ],
  software: [
    { name: "Hexagon", logo: "/api/placeholder/120/60", category: "Digital Solutions" },
    { name: "Knox", logo: "/api/placeholder/120/60", category: "Mobile Security" },
    { name: "Scale Fusion", logo: "/api/placeholder/120/60", category: "Device Management" }
  ]
};

export const team = [
  {
    name: "Ms. Shabana Nasim",
    position: "Managing Director", 
    background: "Seasoned entrepreneur with 20+ years of management experience. MBA from FORE School of Management, Corporate Finance certification from London Business School. Executive Director of BRICS CCI, specializing in e-Governance and driving organizational success through visionary leadership.",
    image: "/api/placeholder/200/200"
  },
  {
    name: "Mr. Mohammed Hussain",
    position: "CEO & Director",
    background: "Seasoned technocrat with 20+ years in senior management at Fortune 500 companies including Panasonic and Samsung. Bachelor of Technology from Shri G.S. Institute, Indore. Expert in driving innovation and growth in technology solutions across global markets.",
    image: "/api/placeholder/200/200"
  },
  {
    name: "Abid Hayat",
    position: "VP of Technology",
    background: "Technology leader with 15+ years of experience in corporate governance and technology innovation. Director roles across multiple companies including NF Infratech. Expert in technology strategy, digital transformation, and leading technology initiatives across MENA region markets.",
    image: "/api/placeholder/200/200"
  },
  {
    name: "Adil Hayat",
    position: "VP of Finance",
    background: "Finance executive with expertise in portfolio management and growth initiatives. Experienced in leading financial operations, strategic planning, and overseeing business portfolios. Brings strong financial acumen and strategic vision to drive NFIT Corp's expansion across the MENA region.",
    image: "/api/placeholder/200/200"
  }
];

export const testimonials = [
  {
    quote: "NFIT Corp transformed our government services with their comprehensive e-governance solutions. The impact on citizen satisfaction has been remarkable.",
    author: "Dr. Mohammed Al-Rashid",
    position: "Director of Digital Services, UAE Government",
    company: "UAE Government"
  },
  {
    quote: "Their IoT solutions helped us optimize our supply chain operations across the MENA region, resulting in 30% cost reduction.",
    author: "Fatima Al-Mansouri",
    position: "Chief Operations Officer",
    company: "MENA Logistics Corp"
  },
  {
    quote: "The blockchain implementation for our financial services has enhanced security and transparency significantly.",
    author: "Omar Ben Ali",
    position: "Head of Technology",
    company: "Gulf Financial Services"
  }
];

export const contactInfo = {
  address: "FZA Business Park, Dubai Silicon Oasis, UAE",
  phone: "+971 55 373 3484",
  email: "abid@nfitcorp.ae",
  website: "www.nfitcorp.ae",
  socialMedia: {
    linkedin: "https://linkedin.com/company/nfitcorp",
    twitter: "https://twitter.com/nfitcorp"
  }
};